import { useReactToPrint, UseReactToPrintOptions } from "react-to-print";

// react-to-print mặc định chép các thẻ <link rel="stylesheet"> sang iframe in rồi để iframe tải lại CSS theo URL.
// Tab mở từ trước lần deploy gần nhất vẫn trỏ tới file CSS mang hash cũ, file đó không còn trên server
// (server trả về index.html) nên bản in mất hết CSS mà thư viện vẫn in tiếp, không báo lỗi.
// Hook này lấy thẳng CSS trang đang dùng từ các stylesheet đã nạp trong bộ nhớ, không tải lại qua mạng.
const getLoadedCss = (): string => {
  const imports: string[] = [];
  const rules: string[] = [];
  Array.from(document.styleSheets).forEach((sheet) => {
    try {
      Array.from(sheet.cssRules).forEach((rule) =>
        (rule instanceof CSSImportRule ? imports : rules).push(rule.cssText),
      );
    } catch {
      // Stylesheet khác origin (vd skin TinyMCE trên CDN) không cho đọc cssRules, bản in không cần tới
    }
  });
  // @import chỉ có hiệu lực khi đứng đầu stylesheet
  return [...imports, ...rules].join("\n");
};

// Dùng thay cho useReactToPrint, cùng options
const usePrintWithLoadedCss = (
  options: Omit<UseReactToPrintOptions, "ignoreGlobalStyles" | "print">,
) =>
  useReactToPrint({
    ...options,
    ignoreGlobalStyles: true,
    print: async (iframe) => {
      const printDocument = iframe.contentDocument;
      if (!printDocument || !iframe.contentWindow) return;

      const style = printDocument.createElement("style");
      style.textContent = getLoadedCss();
      printDocument.head.appendChild(style);

      // print tự truyền vào thì react-to-print bỏ qua documentTitle, nên đặt tiêu đề ở đây như thư viện vẫn làm
      const { documentTitle } = options;
      const ownerTitle = document.title;
      if (documentTitle) document.title = printDocument.title = documentTitle;
      iframe.contentWindow.print();
      if (documentTitle) document.title = ownerTitle;
    },
  });

export default usePrintWithLoadedCss;
